/**
 * Mostrar la diferencia entre dos fechas
 *
 * @param date1
 * @param date2
 * @returns {{hour: number, day: number, minute: number, second: number}}
 */
export default function DifferenceDate(date1, date2) {
    date1 = new Date(date1 * 1000)
    date2 = new Date(date2 * 1000)

    let difference = date1.getTime() - date2.getTime();

    let daysDifference = Math.floor(difference/1000/60/60/24);
    difference -= daysDifference*1000*60*60*24

    let hoursDifference = Math.floor(difference/1000/60/60);
    difference -= hoursDifference*1000*60*60

    let minutesDifference = Math.floor(difference/1000/60);
    difference -= minutesDifference*1000*60

    let secondsDifference = Math.floor(difference/1000);

    return {
        day: daysDifference,
        hour: hoursDifference,
        minute: minutesDifference,
        second: secondsDifference
    }
}
